<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormProveedor" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="NombreComercial">Nombre Comercial</label>
							<input type="text" v-model="objProveedor.NombreComercial" class="form-control" id="NombreComercial" placeholder="Ingresar Nombre Comercial" />
							<CValidation v-if="this.errorvalidacion.NombreComercial" :Mensaje="'*'+errorvalidacion.NombreComercial[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="RazonSocial">Razón Social</label>
							<input type="text" v-model="objProveedor.RazonSocial" class="form-control" id="RazonSocial" placeholder="Ingresar Razón Social" />
							<CValidation v-if="this.errorvalidacion.RazonSocial" :Mensaje="'*'+errorvalidacion.RazonSocial[0]"/>
						</div>
					</div>
					
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="RFC">RFC</label>
							<input type="text" v-model="objProveedor.RFC" class="form-control" id="RFC" placeholder="Ingresar RFC" />
							<CValidation v-if="this.errorvalidacion.RFC" :Mensaje="'*'+errorvalidacion.RFC[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="Banco">Banco</label>
							<input type="text" v-model="objProveedor.Banco" class="form-control" id="Banco" placeholder="Ingresar Banco" />
							<CValidation v-if="this.errorvalidacion.Banco" :Mensaje="'*'+errorvalidacion.Banco[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="NCuenta">N° de Cuenta</label>
							<input type="text" v-model="objProveedor.NCuenta" class="form-control" id="NCuenta" placeholder="Ingresar N° de Cuenta" />
							<CValidation v-if="this.errorvalidacion.NCuenta" :Mensaje="'*'+errorvalidacion.NCuenta[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="Clabe">Clabe Interbancaria</label>
							<input type="text" v-model="objProveedor.Clabe" class="form-control" id="Clabe" placeholder="Ingresar Clabe Interbancaria" />
							<CValidation v-if="this.errorvalidacion.Clabe" :Mensaje="'*'+errorvalidacion.Clabe[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="Tarjeta">N° de Tarjeta</label>
							<input type="text" v-model="objProveedor.Tarjeta" class="form-control" id="Tarjeta" placeholder="Ingresar N° de Tarjeta" />
							<CValidation v-if="this.errorvalidacion.Tarjeta" :Mensaje="'*'+errorvalidacion.Tarjeta[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Direccion">Dirección</label>
							<textarea v-model="objProveedor.Direccion" class="form-control" id="Direccion" placeholder="Ingresar Dirección" rows="2"></textarea>
							<CValidation v-if="this.errorvalidacion.Direccion" :Mensaje="'*'+errorvalidacion.Direccion[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="CP">CP</label>
							<input type="text" v-model="objProveedor.CP" class="form-control" id="CP" placeholder="Ingresar Código Postal" />
							<CValidation v-if="this.errorvalidacion.CP" :Mensaje="'*'+errorvalidacion.CP[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="Telefono">Teléfono</label>
							<input type="text" v-model="objProveedor.Telefono" class="form-control" id="Telefono" placeholder="Ingresar Teléfono" />
							<CValidation v-if="this.errorvalidacion.Telefono" :Mensaje="'*'+errorvalidacion.Telefono[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="Movil">Móvil</label>
							<input type="text" v-model="objProveedor.Movil" class="form-control" id="Movil" placeholder="Ingresar Móvil" />
							<CValidation v-if="this.errorvalidacion.Movil" :Mensaje="'*'+errorvalidacion.Movil[0]"/>
						</div>
					</div>
					
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="Ciudad">Ciudad</label>
							<input type="text" v-model="objProveedor.Ciudad" class="form-control" id="Ciudad" placeholder="Ingresar Ciudad" />
							<CValidation v-if="this.errorvalidacion.Ciudad" :Mensaje="'*'+errorvalidacion.Ciudad[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="Estado">Estado</label>
							<input type="text" v-model="objProveedor.Estado" class="form-control" id="Estado" placeholder="Ingresar Estado" />
							<CValidation v-if="this.errorvalidacion.Estado" :Mensaje="'*'+errorvalidacion.Estado[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="Correo">Correo</label>
							<input type="text" v-model="objProveedor.Correo" class="form-control" id="Correo" placeholder="Ingresar Correo" />
							<CValidation v-if="this.errorvalidacion.Correo" :Mensaje="'*'+errorvalidacion.Correo[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="Contacto">Contacto</label>
							<input type="text" v-model="objProveedor.Contacto" class="form-control" id="Contacto" placeholder="Ingresar Contacto" />
							<CValidation v-if="this.errorvalidacion.Contacto" :Mensaje="'*'+errorvalidacion.Contacto[0]"/>
						</div>
					</div>
					
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="DiasCredito">Días de Crédito</label>
							<input type="text" v-model="objProveedor.DiasCredito" class="form-control" id="DiasCredito" placeholder="Ingresar Dias de Credito" />
							<CValidation v-if="this.errorvalidacion.DiasCredito" :Mensaje="'*'+errorvalidacion.DiasCredito[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="IdProductoCategoria">Categoría</label>
							<!-- <select v-model="objProveedor.IdProductoCategoria" class="form-control-search form-select" id="IdProductoCategoria">
								<option value="">Seleccione una Categoría</option>
								<option v-for="(item, index) in Categorias" :key="index" :value="item.IdProductoCategoria">{{item.Nombre}}</option>
							</select> -->
							<treeselect
								:options="Categorias"
								:placeholder="'Seleccione una Categoría'"
								v-model="objProveedor.IdProductoCategoria"
								>
								<!-- <h6 slot="before-list">Seleccione una Categoría</h6> -->
							</treeselect>
							<CValidation v-if="this.errorvalidacion.IdProductoCategoria" :Mensaje="'*'+errorvalidacion.IdProductoCategoria[0]"/>
						</div>
					</div>
					
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormProveedor',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objProveedor: {
				IdProveedor: 0,
				NombreComercial: '',
				RazonSocial: '',
				RFC: '',
				NCuenta: '',
				Banco: '',
				Clabe: '',
				Tarjeta: '',
				Direccion: '',
				CP: '',
				Telefono: '',
				Movil: '',
				Correo: '',
				Estado: '',
				Ciudad: '',
				DiasCredito: 0,
				IdProductoCategoria: "",
				Contacto: '',
				
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
			Categorias:[]
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objProveedor.IdProveedor == 0) {
				await this.$http.post(
					'proveedores',this.objProveedor
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'proveedores/'+this.objProveedor.IdProveedor,
					this.objProveedor
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "proveedores/"+this.objProveedor.IdProveedor
            ).then((res) => {
                this.objProveedor = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objProveedor.Fecha.replace(/-/g,'\/');
                this.objProveedor.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objProveedor = {
				IdProveedor: 0,
				NombreComercial: '',
				RazonSocial: '',
				RFC: '',
				NCuenta: '',
				Banco: '',
				Clabe: '',
				Tarjeta: '',
				Direccion: '',
				CP: '',
				Telefono: '',
				Movil: '',
				Correo: '',
				Estado: '',
				Ciudad: '',
				DiasCredito: 0,
				IdProductoCategoria: null,
				Contacto: '',
				
            }
            this.errorvalidacion = [];
        },
		ListaCategorias(){
			this.$http.get('productosCategoria/simple',{
				params:{
				}
			}).then((res)=>{
				this.Categorias=res.data.data.map(function(obj){
					return {
						id:obj.IdProductoCategoria,
						label:obj.Nombre
					}
				});
				// this.Categorias.push({id:"",label:''});
			})
		}
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;
			this.ListaCategorias();

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objProveedor.IdProveedor = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
